import React, { useEffect, useState } from 'react';
import MyGoogleMap from 'components/Common/Maps/MyGoogleMap';
import { PropTypes } from 'prop-types';
import * as Yup from 'yup';
import { useNibbleForm } from 'components/Nibble/Hooks/UseNibbleForm';
import { Alert, Button, Card, CardBody, Col, Form, Offcanvas, OffcanvasBody, OffcanvasHeader, Row, Table } from 'reactstrap';

import { MEXICO_STATES } from 'helpers/states';
import { getProducts, postBranche, postDelivery, putBranch, putDevelivery } from 'helpers/backend_helper';

const cpRegExp = /^[0-9]{5}/;

const Trucks = ({ model, setModel }) => {
    const [curAddress, setCurAddress] = useState({
        country: 'México',
    })
    const [offCanvasIsOpen, setOffCanvasIsOpen] = useState(false)
    const [error, setError] = useState("")
    const [completed, setCompleted] = useState("")
    const [btnSaveLoad, setBtnSaveLoad] = useState(false)
    const [position, setPosition] = useState(null)
    const [selectedRegion, setSelectedRegion] = useState(model.invoice_address?.region_id)
    const [products, setProducts] = useState([])

    const addFarm = (indexFarm, edit = false) => {
        let farm = { ... (indexFarm != null ? model.farms[indexFarm] : {}) }
        if (farm) {
            delete farm?.address?.enterprise_id
        }
        farm = { ...farm.address, ...farm, gps: farm.address?.gps || null }
        farm.edit = edit
        farm.indexItem = indexFarm
        setCurAddress(farm)
        //setPosition(farm?.gps ? { lat: farm?.gps.split(",")[0], lng: farm?.gps.split(",")[1] } : null)
        setOffCanvasIsOpen(true)
    }

    const delFarm = indexFarm => {
        // Delete Farm
    }

    const toggleRightCanvas = () => {
        setCompleted(null)
        setOffCanvasIsOpen(!offCanvasIsOpen)
    }

    const { validation, render } = useNibbleForm({
        formScheme: [
            { md: 12, name: 'name', label: 'Nombre', type: 'text' },
            { md: 12, name: 'regions', label: 'Zonas de cobertura', type: 'multi-select', selectItems: MEXICO_STATES, selectOptionValue: (option) => `${option.name}` },
            { md: 12, name: 'products', label: 'Productos', type: 'multi-select', selectItems: products }
        ],
        validationScheme: Yup.object().shape({
            name: Yup.string().required('Requerido'),
            regions: Yup.array().min(1, 'Seleccione al menos una zona de cobertura').required('Requerido'),
            products: Yup.array().min(1, 'Seleccione al menos un producto').required('Requerido'),
        }),
        defaultModelValues: {
            regions: [],
            products: [],
        },
        model: curAddress,
        onSubmit: async (values) => {
            console.log('values', values)
            setCurAddress({ ...curAddress, ...values })
            setBtnSaveLoad(true)
            try {
                const obj = JSON.parse(localStorage.getItem("authUser"))
                console.log('user', obj.user);
                console.log('modelo', { id: model.id, ...values })

                let newModel = {}
                let payload = {
                    ...values,
                    address: {
                        street: values.street,
                        ext_num: values.ext_num,
                        int_num: values.int_num,
                        location: values.location,
                        city: values.city,
                        state: MEXICO_STATES.find(s => s.id == values.state)?.name || values.state,
                        country: values.country,
                        cp: values.cp,
                        gps: values.gps,
                        goo_address: values.goo_address,
                        region_id: selectedRegion,
                    },
                }
                if ('indexItem' in curAddress && curAddress.indexItem != null) {
                    const response = await putBranch(model.id, { id: curAddress.id, ...payload, region_id: selectedRegion })
                    newModel = { ...model }
                    newModel.farms[curAddress.indexItem] = response;
                } else {
                    const response = await postBranche(model.id, { ...payload, region_id: selectedRegion })
                    newModel = { ...model }
                    newModel.farms.push(response)
                    toggleRightCanvas()
                }

                setModel(newModel)
                setError(null)
                setCompleted('Se completo la operación')
            } catch (error) {
                console.log(error)
                setError(error.toString())
                setCompleted(null)
            }
            setBtnSaveLoad(false)
        }
    });

    useEffect(() => {
        getProducts().then(setProducts)
    }, [])

    return (
        <>
            <Card>
                <CardBody>
                    <table className="table table-responsive table-bordered table-sm">
                        <thead>
                            <tr className='bg-light'>
                                <th>Camión</th>
                                <th>Zonas de cobertura</th>
                                <th>Productos / Capacidad</th>
                                <th>Total Capacidad</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(model.farms || []).map((farm, key) => (
                                <tr key={key}>
                                    <td>{farm.name}</td>
                                    <td>
                                        {farm.regions
                                            ? farm.regions.reduce((prev, cur) => {
                                                return (
                                                    prev +
                                                    ("label" in cur ? cur.label : cur.name) +
                                                    " - "
                                                )
                                            }, "")
                                            : ""}
                                    </td>
                                    <td>
                                        {(farm.products || []).map((item) => {
                                            return (
                                                <>
                                                    {item.name}: 200 piezas <br />
                                                </>
                                            )
                                        })}
                                    </td>
                                    <td>
                                        1000 piezas
                                    </td>
                                    <td>
                                        <Button
                                            type="button"
                                            className="btn btn-warning btn-sm"
                                            onClick={() => addFarm(key, true)}
                                        >
                                            <i className="fas fa-edit"></i>
                                        </Button>{" "}
                                        <Button
                                            type="button"
                                            className="btn btn-danger btn-sm"
                                            onClick={() => delFarm(key)}
                                        >
                                            <i className="fas fa-trash"></i>
                                        </Button>
                                    </td>
                                </tr>

                            ))}
                            {model.deliveries_address?.length == 0 && (
                                <tr>
                                    <td colSpan={6} className="text-center">Sin Camiones</td>
                                </tr>
                            )}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={6} className="text-center">
                                    <Button type="button" className="btn btn-danger btn-sm" onClick={() => addFarm()}>
                                        <i className="fas fa-plus"></i> Agregar camión
                                    </Button>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </CardBody>
            </Card>
            <Offcanvas
                isOpen={offCanvasIsOpen}
                direction="end"
                toggle={toggleRightCanvas}
            >
                <OffcanvasHeader toggle={toggleRightCanvas}>
                    {'edit' in curAddress && curAddress.edit ? 'Modificar camión' : 'Nuevo camión'}
                </OffcanvasHeader>
                <OffcanvasBody>
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            console.log('submit');
                            e.preventDefault();
                            validation.handleSubmit(e)
                            return false;
                        }}
                    >
                        {error ? <Alert color="danger">{error}</Alert> : null}
                        {completed ? <Alert color="success">{completed}</Alert> : null}
                        <Row>
                            {
                                //JSON.stringify(position)
                            }
                            {render()}
                        </Row>
                        <Row className='mt-4'>
                            <Col md={12}>
                                <Table bordered size='sm' striped>
                                    <thead>
                                        <tr className='bg-light'>
                                            <th>Producto</th>
                                            <th>Capacidad (piezas)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(validation.values.products || []).map((item, key) => (
                                            <tr key={key}>
                                                <td>{'label' in item ? item.label : item.name}</td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        className="form-control form-control-sm"
                                                        value={item.capacity || ''}
                                                        onChange={(e) => {
                                                            let newProducts = [...validation.values.products]
                                                            newProducts[key] = { ...newProducts[key], capacity: e.target.value }
                                                            validation.setFieldValue('products', newProducts)
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>

                        <div className="text-center mt-3">
                            <button type="submit" className="btn btn-sm btn-danger w-md" disabled={btnSaveLoad}>
                                <i className="fas fa-save"></i> Guardar
                            </button>
                            <button type="button" className="btn btn-sm btn-danger w-md ms-2" disabled={btnSaveLoad} onClick={toggleRightCanvas}>
                                <i className="fas fa-reply"></i> Cerrar
                            </button>
                        </div>
                    </Form>
                </OffcanvasBody>
            </Offcanvas>
        </>
    );
};

Trucks.propTypes = {
    model: PropTypes.object.isRequired,
    setModel: PropTypes.func.isRequired,
};

export default Trucks;